import { render } from "./TemplateModalEvent.vue?vue&type=template&id=7d828533&ts=true"
import script from "./TemplateModalEvent.vue?vue&type=script&lang=ts"
export * from "./TemplateModalEvent.vue?vue&type=script&lang=ts"

import "./TemplateModalEvent.vue?vue&type=style&index=0&id=7d828533&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__